import * as types from "./candidateListingActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  error: null,
  isError: false
};

const initialState = {
  applicants: {
    ...stateObject,
    candidateList: {
      recommended: [],
      applied: [],
      contacted: [],
      shortlisted: []
    }
  },
  selectedApplicant: { ...stateObject },
  reportCandidates: { ...stateObject },
  changeStatus: { ...stateObject },
  feedbackStatus: { ...stateObject },
  helpFeedbackStatus: { ...stateObject },
  contactDetails: { ...stateObject },
  filterState: [],
  error: null,
  isError: false
};

export default function candidateListingReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_APPLICANTS_LOADING:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: true
        }
      };
    case types.GET_APPLICANTS_SUCCESS:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload.applicantData,
          candidateList: {
            ...state.candidateList,
            recommended: action.payload.recommended,
            applied: action.payload.applied,
            contacted: action.payload.contacted,
            shortlisted: action.payload.shortlisted
          }
        }
      };
    case types.GET_APPLICANTS_FAILURE:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_SELECT_APPLICANT_LOADING:
      return {
        ...state,
        selectedApplicant: {
          ...state.selectedApplicant,
          isLoading: true
        }
      };
    case types.GET_SELECT_APPLICANT_SUCCESS:
      return {
        ...state,
        selectedApplicant: {
          ...state.selectedApplicant,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_SELECT_APPLICANT_FAILURE:
      return {
        ...state,
        selectedApplicant: {
          ...state.selectedApplicant,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.REPORT_APPLICANTS_LOADING:
      return {
        ...state,
        reportCandidates: {
          ...state.reportCandidates,
          isLoading: true
        }
      };
    case types.REPORT_APPLICANTS_SUCCESS:
      return {
        ...state,
        reportCandidates: {
          ...state.reportCandidates,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.REPORT_APPLICANTS_FAILURE:
      return {
        ...state,
        reportCandidates: {
          ...state.reportCandidates,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.CHANGE_APPLICATION_STATUS_LOADING:
      return {
        ...state,
        changeStatus: {
          ...state.changeStatus,
          isLoading: true
        }
      };
    case types.CHANGE_APPLICATION_STATUS_SUCCESS:
      return {
        ...state,
        changeStatus: {
          ...state.changeStatus,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.CHANGE_APPLICATION_STATUS_FAILURE:
      return {
        ...state,
        changeStatus: {
          ...state.changeStatus,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.SAVE_FEEDBACK_LOADING:
      return {
        ...state,
        feedbackStatus: {
          ...state.feedbackStatus,
          isLoading: true
        }
      };
    case types.SAVE_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackStatus: {
          ...state.feedbackStatus,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SAVE_FEEDBACK_FAILURE:
      return {
        ...state,
        feedbackStatus: {
          ...state.feedbackStatus,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.SAVE_HELP_FEEDBACK_LOADING:
      return {
        ...state,
        helpFeedbackStatus: {
          ...state.helpFeedbackStatus,
          isLoading: true
        }
      };
    case types.SAVE_HELP_FEEDBACK_SUCCESS:
      return {
        ...state,
        helpFeedbackStatus: {
          ...state.helpFeedbackStatus,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SAVE_HELP_FEEDBACK_FAILURE:
      return {
        ...state,
        helpFeedbackStatus: {
          ...state.helpFeedbackStatus,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.GET_CONTACT_DETAILS_LOADING:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          isLoading: true
        }
      };
    case types.GET_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_CONTACT_DETAILS_FAILURE:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.GET_CANDIDATE_LISTING_FILTERS:
      return {
        ...state,
        filterState: action.payload
      };

    default:
      return state;
  }
}
